import React from "react";
import theme from "../../../assets/theme";
import CaseService from "../../../services/CaseService";
import { getErrorMessage } from "../../../helpers/functions";
import { useSnackbar } from "notistack";
import CustomSelect from "../../common/CustomSelect/CustomSelectDoc";
import useLoader from "../../../hooks/useLoader";
// import { caseDocumentType } from "../../../helpers/constants";
import styled from "styled-components";

const DocChangeType = ({ rowData, MTRef }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();
  let docId = rowData?.id;
  let caseId = rowData?.entityId;

  const changeDocType = async (value) => {
    try {
      setLoader({ state: true, message: "Change Document..." });
      const payload = {
        uploadType: value,
      };
      const res = await CaseService.changeDocType(payload, caseId, docId);
      if (res) {
        enqueueSnackbar("Document Type Changed Successfully", {
          variant: "success",
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      MTRef.current.onQueryChange("");
    }
  };

  const caseDocumentType = [
    { label: "Select Document Type", value: "", disabled: true },
    {
      label:
        "IIAC Case Portal to be capable to file all documents as are provided in A and B above",
      value:
        "IIAC Case Portal to be capable to file all documents as are provided in A and B above",
      color: "#0000FF",
    },
    {
      label:
        "Documents/order(s) passed by the Hon’ble Chairperson in the matters of appointment of the Arbitrators",
      value:
        "Documents/order(s) passed by the Hon’ble Chairperson in the matters of appointment of the Arbitrators",
      color: "#FF1493",
    },
    {
      label:
        "Documents/order(s) passed by the Hon’ble Chairperson in the matters relating to various applications may be filed as per the IIAC Regulations",
      value:
        "Documents/order(s) passed by the Hon’ble Chairperson in the matters relating to various applications may be filed as per the IIAC Regulations",
      color: "#4B0082",
    },
    {
      label:
        "Documents/order(s) passed by the Arbitral Tribunal in the matters relating to various applications may be filed as per the IIAC Regulations",
      value:
        "Documents/order(s) passed by the Arbitral Tribunal in the matters relating to various applications may be filed as per the IIAC Regulations",
      color: "#8B008B",
    },
    {
      label: "Various order/procedural orders passed by the Arbitral Tribunal",
      value: "Various order/procedural orders passed by the Arbitral Tribunal",
      color: "#006400",
    },
    {
      label: "Various correspondences exchanged between IIAC/Parties/Tribunal",
      value: "Various correspondences exchanged between IIAC/Parties/Tribunal",
      color: "#d91b1b",
    },
    {
      label:
        "Various invoices/payment related document regarding – Filing Fee, Administration Fee, Arbitrators Fee, Misc. Administration Charges etc. as per the IIAC Regulations",
      value:
        "Various invoices/payment related document regarding – Filing Fee, Administration Fee, Arbitrators Fee, Misc. Administration Charges etc. as per the IIAC Regulations",
      color: "#FF7F50",
    },
    {
      label: "Any other document",
      value: "Any other document",
      color: "#00838c",
    },
    {
      label:
        rowData?.url?.uploadType ===
        "IIAC Case Portal to be capable to file all documents as are provided in A and B above"
          ? null
          : rowData?.url?.uploadType ===
            "Documents/order(s) passed by the Hon’ble Chairperson in the matters of appointment of the Arbitrators"
          ? null
          : rowData?.url?.uploadType ===
            "Documents/order(s) passed by the Hon’ble Chairperson in the matters relating to various applications may be filed as per the IIAC Regulations"
          ? null
          : rowData?.url?.uploadType ===
            "Documents/order(s) passed by the Arbitral Tribunal in the matters relating to various applications may be filed as per the IIAC Regulations"
          ? null
          : rowData?.url?.uploadType ===
            "Various order/procedural orders passed by the Arbitral Tribunal"
          ? null
          : rowData?.url?.uploadType ===
            "Various correspondences exchanged between IIAC/Parties/Tribunal"
          ? null
          : rowData?.url?.uploadType ===
            "Various invoices/payment related document regarding – Filing Fee, Administration Fee, Arbitrators Fee, Misc. Administration Charges etc. as per the IIAC Regulations"
          ? null
          : rowData?.url?.uploadType === "Any other document"
          ? null
          : `${rowData?.url?.uploadType} (Others)`,
      value: rowData?.url?.uploadType,
      disabled: true,
      color: "#5A5A5A",
    },
  ];

  return (
    <Container className="invoice">
      <CustomSelect
        menuItemValues={caseDocumentType}
        name={rowData?.url?.uploadType}
        value={rowData?.url?.uploadType}
        disabled={
          rowData?.url?.uploadType === "Arbitration Notice" ? true : false
        }
        onChange={(e) => changeDocType(e.target.value)}
      />
    </Container>
  );
};

export default DocChangeType;

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  @media ${theme?.breakpoints?.sm_up} {
    width: auto;
  }
`;
